import { render } from "./ItineraryFilter.vue?vue&type=template&id=28879063"
import script from "./ItineraryFilter.vue?vue&type=script&lang=js"
export * from "./ItineraryFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__